import { useState } from "react";

import SwipeableViews from "react-swipeable-views";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import EmailIcon from "@mui/icons-material/Email";
import IconButton from "@mui/material/IconButton";
import PhoneIcon from "@mui/icons-material/Phone";
import StyledTooltip from "../UI/StyledTooltip";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";

import ProjectLinks from "./ProjectLinks";
import TabPanel, { a11yProps } from "../UI/StyledTabPanel";
import { styles } from "../../config/config.theme";

import classes from "./ProjectContents.module.css";

const msTeamsLogo = require("../../assets/msTeamsLogo.png");

function ProjectContents({ projectInfo, showLayerControl, style }) {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const tabStyle = {
    textTransform: "capitalize",
    fontSize: "0.8rem",
    minWidth: "50px",
    color: styles["text-primary"],
  };

  const iconButtonStyle = {
    height: "40px",
    width: "40px",
  };

  return (
    <div
      className={classes["layer-control-container"]}
      style={{
        width: "100%",
        display: showLayerControl ? "block" : "none",
        backgroundColor:
          style && style.backgroundColor ? style.backgroundColor : "",
        color: style && style.color ? style.color : "",
      }}
    >
      <Box sx={{ backgroundColor: "transparent", width: "100%" }}>
        <AppBar
          position="static"
          sx={{
            backgroundColor: "transparent",
            boxShadow:
              "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%)",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="project tabs"
          >
            <Tab label="Contacts" {...a11yProps(0)} sx={tabStyle} />
            <Tab label="Quick Links" {...a11yProps(1)} sx={tabStyle} />
            <Tab label="Products" {...a11yProps(2)} sx={tabStyle} />
            <Tab label="Resources" {...a11yProps(3)} sx={tabStyle} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            {projectInfo?.people ? projectInfo?.people.map((contact, index) => (
              <div key={index} className={classes.contactsContainer}>
                <div className={classes.contactNameContainer}>
                  <p className={classes.contactName}>{`${contact.person.first_name} ${contact.person.last_name}`}</p>
                  <p
                    className={classes.contactTitle}
                    style={{
                      color:
                        style && style.linkSecondaryColor
                          ? style.linkSecondaryColor
                          : "",
                    }}
                  >
                    {contact.role.name}
                  </p>
                </div>

                <div className={classes.contactButtonsContainer}>
                  <StyledTooltip title={contact.person.phone}>
                    <IconButton
                      aria-label="phone"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          contact.person.phone
                        );
                      }}
                      sx={iconButtonStyle}
                    >
                      <PhoneIcon color="primary" />
                    </IconButton>
                  </StyledTooltip>
                  <StyledTooltip title="Send email">
                    <IconButton
                      aria-label="email"
                      href={`mailto:${contact.person.email}`}
                    >
                      <EmailIcon color="primary" />
                    </IconButton>
                  </StyledTooltip>
                  <StyledTooltip title="Message on Teams">
                    <IconButton
                      aria-label="Microsoft Teams"
                      href={`https://teams.microsoft.com/l/chat/0/0?users=${contact.person.email}`}
                      target="_blank"
                      rel="noopener"
                    >
                      <img
                        src={msTeamsLogo}
                        alt={"Microsoft Teams Logo"}
                        loading="lazy"
                        style={{ height: "20px", width: "20px" }}
                      />
                    </IconButton>
                  </StyledTooltip>
                </div>
              </div>
            )) : null }
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <ProjectLinks links={projectInfo?.quickLinks} style={style} />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <ProjectLinks links={projectInfo?.products} style={style} />
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <ProjectLinks links={projectInfo?.otherResources} style={style} />
          </TabPanel>
        </SwipeableViews>
      </Box>
    </div>
  );
}

export default ProjectContents;
